import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
import ProductFilterTable from "../components/ProductFilterTable";
import { useProductContext } from "../context/productContext";
import axios from "../helper/axios";
import "./FilterProductPage.css";

const FilterProductPage = () => {
  const { isLoading, products } = useProductContext();
  const [myData, setMyData] = useState([]);
  const [isError, setIsError] = useState("");

  const [colorSlider, setColorSlider] = useState([0, 0]);
  const [shapeSlider, setShapeSlider] = useState([0, 0]);
  const [cutSlider, setCutSlider] = useState([0, 0]);
  const [caratSlider, setCaratSlider] = useState([0, 0]);
  const [priceSlider, setPriceSlider] = useState([0, 0]);

  const [colorSliderValue, setColorSliderValue] = useState([]);
  const [shapeSliderValue, setShapeSliderValue] = useState([]);
  const [cutSliderValue, setCutSliderValue] = useState([]);
  const [caratSliderValue, setCaratSliderValue] = useState([]);
  const [priceSliderValue, setPriceSliderValue] = useState([]);

  const getUniqueData = (data, attr) => {
    return [...new Set(data.map((myData) => myData[attr]))];
  };

  const colorData = getUniqueData(products, "color");
  const shapeData = getUniqueData(products, "shape");
  // const shapeData = ['Round', 'Oval', 'Cushion'];
  const cutData = getUniqueData(products, "cut");
  const caratData = getUniqueData(products, "carat");
  const priceData = getUniqueData(products, "price");

  colorData.sort();
  caratData.sort();
  cutData.sort();
  // shapeData.sort();
  priceData.sort();

  const caratMarks = caratData.reduce((acc, carat, index) => {
    acc[index] = carat;
    return acc;
  }, {});

  const colorMarks = colorData.reduce((acc, color, index) => {
    acc[index] = color;
    return acc;
  }, {});

  const shapeMarks = shapeData.reduce((acc, shape, index) => {
    acc[index] = shape;
    return acc;
  }, {});

  // const shapeMarks = {0: 'Round', 1: 'Oval', 2: 'Cushion'}

  const cutMarks = cutData.reduce((acc, cut, index) => {
    acc[index] = cut;
    return acc;
  }, {});

  const priceMarks = priceData.reduce((acc, price, index) => {
    acc[index] = price;
    return acc;
  }, {});

  useEffect(() => {
    // console.log('timepass', cutData);
    setColorSlider([0, colorData.length - 1]);
    setColorSliderValue([colorData[0], colorData[colorData.length - 1]]);

    setShapeSlider([0, shapeData.length - 1]);
    // console.log('on load shapedata', shapeData);
    setShapeSliderValue([shapeData[0], shapeData[shapeData.length - 1]]);

    setCutSlider([0, cutData.length - 1]);
    setCutSliderValue([cutData[0], cutData[cutData.length - 1]]);

    setCaratSlider([0, caratData.length - 1]);
    setCaratSliderValue([caratData[0], caratData[caratData.length - 1]]);
    // console.log('caratSliderValue', caratData);

    setPriceSlider([0, priceData.length - 1]);
    setPriceSliderValue([priceData[0], priceData[priceData.length - 1]]);

    // setMyData(products);

    // console.log('colorSliderValue', colorSliderValue);
    // console.log('shapeSliderValue', shapeSliderValue);
    // console.log('cutSliderValue', cutSliderValue);
    // console.log('caratSliderValue', caratSliderValue);
    // console.log('caratData', caratData);
    // console.log('caratMarks', caratMarks);
  }, [products]);

  // http://ec2-34-197-250-249.compute-1.amazonaws.com/api/product_read?
  // from_color=D&to_color=H  &shape=Round&shape=Cushion  &from_cut=Fair&to_cut=Very%20Good  &min_carat=1&max_carat=5  &from_price=100&to_price=25000

  const getAPIData1 = async () => {
    try {
      let url = "/product_read?";
      if (colorSliderValue.length > 0) {
        url += `from_color=${colorSliderValue[0]}&to_color=${colorSliderValue[1]}`;
      }

      // if (shapeSliderValue.length > 0) {
      //     url += `&shape=${shapeSliderValue[0]}&shape=${shapeSliderValue[1]}`;
      //     // console.log('on api call shapedata 3', shapeSliderValue);
      // }
      // console.log('on api call shapedata', shapeData);
      // if (shapeSliderValue.length === 1) {
      //     url += `&shape=${shapeSliderValue[0]}`;
      //     console.log('on api call shapedata 1', shapeSliderValue);
      // }
      // if (shapeSliderValue.length === 2) {
      //     url += `&shape=${shapeSliderValue[0]}&shape=${shapeSliderValue[1]}`;
      //     console.log('on api call shapedata 2', shapeSliderValue);
      // }
      // if (shapeSliderValue.length === 3) {
      //     url += `&shape=${shapeSliderValue[0]}&shape=${shapeSliderValue[1]}&shape=${shapeSliderValue[2]}`;
      //     console.log('on api call shapedata 3', shapeSliderValue);
      // }

      // if (shapeSliderValue.length > 0) {
      //     {
      //         shapeData.map((shape) => (
      //             url += `&shape=${shape}`, console.log('avasvsa',shape)
      //         ))
      //     }
      //     // console.log('on api call shapedata 3', shapeSliderValue);
      // }

      // const lastIndex = shapeData.length - 1;
      // console.log('lastIndex', lastIndex);
      // const start = shapeSlider[0];
      // const end = shapeSlider[1];
      // const sum = shapeData.slice(start, end + 1).join(', ');
      // console.log(sum);

      if (shapeSliderValue.length > 0) {
        const start = shapeSlider[0];
        const end = shapeSlider[1];
        const sum = shapeData.slice(start, end + 1);

        // console.log('̥sum', sum);
        sum.map(
          (shape) =>
            (url += `&shape=${shape}`)
            // console.log('̥', shape)
        );
      }

      // if (shapeSliderValue[0] === shapeData[0] && shapeSliderValue[1] === shapeData[3]) {
      //     // url += `&shape=${shapeSliderValue[0]}&shape=${shapeSliderValue[1]}&shape=Round&shape=oval`;
      //     // console.log('on api call shapedata 3', url);
      //     // shapeData.map((shape) => (
      //     //     url += `&shape=${shape}`
      //     //     // console.log('̥', shape),
      //     //     ))
      // } else {
      //     url += `&shape=${shapeSliderValue[0]}&shape=${shapeSliderValue[1]}`;
      //     // console.log('on api call shapedata', shapeSliderValue);
      // }
      // console.log('̥', shapeSliderValue)

      // console.log('̥shapeSliderValue', shapeSliderValue[0]);
      // if (shapeSliderValue.length > 0) {
      // }
      // console.log('on api call shapedata all', shapeSliderValue.length);

      if (cutSliderValue.length > 0) {
        url += `&from_cut=${cutSliderValue[0]}&to_cut=${cutSliderValue[1]}`;
      }
      if (caratSliderValue.length > 0) {
        url += `&min_carat=${caratSliderValue[0]}&max_carat=${caratSliderValue[1]}`;
      }
      if (priceSliderValue.length > 0) {
        url += `&from_price=${priceSliderValue[0]}&to_price=${priceSliderValue[1]}`;
      }

      const res = await axios.get(url);
      const json = await res.data.products;
      // console.log('json', caratSliderValue);
      // console.log('json', priceSliderValue);
      setMyData(json);
    } catch (error) {
      setIsError(error.message);
    }
  };
  // console.log('on api call shapedata', shapeData);
  // getAPIData1();

  useEffect(() => {
    // console.log('on api call shapedata', shapeData);
    getAPIData1();
  }, [
    colorSliderValue,
    shapeSliderValue,
    cutSliderValue,
    caratSliderValue,
    priceSliderValue,
  ]); //cutSlider, caratSlider, priceSlider]);

  // const colorData = getUniqueData(products, "color");
  // const shapeData = getUniqueData(products, "shape");
  // const cutData = getUniqueData(products, "cut");
  // const caratData = getUniqueData(products, "carat");
  // const priceData = getUniqueData(products, "price");

  if (isLoading) {
    return <div>...Loading</div>;
  }

  // const caratMarks = caratData.reduce((acc, carat, index) => {
  //     acc[index] = carat;
  //     return acc;
  // }, {});

  const onChangeColorSlider = (value) => {
    setColorSlider(value);
    if (value[0] === 0 && value[1] === colorData.length - 1) {
      // All values are selected, set the slider value to the entire range
      setColorSliderValue([]);
    } else {
      const colorRange = [colorData[value[0]], colorData[value[1]]];
      setColorSliderValue(colorRange);
    }
  };

  const onChangeShapeSlider = (value) => {
    setShapeSlider(value);
    // if (value[0] === 0 && value[1] === shapeData.length - 1) {
    //     // All values are selected, set the slider value to the entire range
    //     setShapeSliderValue([]);
    // }
    // // const shapeRange = shapeData.slice(value[0], value[1] + 1);
    // else {
    const shapeRange = [shapeData[value[0]], shapeData[value[1]]];
    setShapeSliderValue(shapeRange);

    // console.log('on change shapedata', shapeData);
  };

  const onChangeCutSlider = (value) => {
    setCutSlider(value);
    if (value[0] === 0 && value[1] === cutData.length - 1) {
      // All values are selected, set the slider value to the entire range
      setCutSliderValue([]);
    } else {
      const cutRange = [cutData[value[0]], cutData[value[1]]];
      // const cutRange = cutData.slice(value[0], value[1] + 1);
      setCutSliderValue(cutRange);
    }
  };

  const onChangeCaratSlider = (value) => {
    setCaratSlider(value);
    if (value[0] === 0 && value[1] === caratData.length - 1) {
      // All values are selected, set the slider value to the entire range
      setCaratSliderValue([]);
    } else {
      // const caratRange = [caratData[value[0]], caratData[value[1]]];
      const caratRange = [caratData[value[0]], caratData[value[1]]];
      setCaratSliderValue(caratRange);
    }
  };

  const onChangePriceSlider = (value) => {
    setPriceSlider(value);
    if (value[0] === 0 && value[1] === priceData.length - 1) {
      // All values are selected, set the slider value to the entire range
      setPriceSliderValue([]);
    } else {
      // const priceRange = [priceData[value[0]], priceData[value[1]]];
      const priceRange = [priceData[value[0]], priceData[value[1]]];
      setPriceSliderValue(priceRange);
    }
  };

  // console.log('̥', myData[0]);

  return (
    <>
      <section className="light-section product-filter-section pt-0">
        <div className="page-banner hero-container">
          <div className="banner-content">
            <h1>Search Loose Lab Grown Diamonds</h1>
          </div>
        </div>
        <div className="container mb-5">
          <div className="row">
            <div className="col-sm-6 mt-5 d-flex align-itmes-center">
              <h4 className="w-10 filter_title">Color</h4>
              <div className="pr-2 w-80">
                <Slider
                  range
                  min={0}
                  marks={colorMarks}
                  max={colorData.length - 1}
                  step={1}
                  onChange={onChangeColorSlider}
                  value={colorSlider}
                />
              </div>
            </div>
            <div className="col-sm-6 mt-5 d-flex align-itmes-center">
              <h4 className="w-10 filter_title">Shape</h4>
              <div className="w-80 pr-2">
                <Slider
                  range
                  min={0}
                  marks={shapeMarks}
                  max={shapeData.length - 1}
                  step={1}
                  onChange={onChangeShapeSlider}
                  value={shapeSlider}
                />
              </div>
            </div>
            <div className="col-sm-6 mt-5 d-flex align-itmes-center">
              <h4 className="w-10 filter_title">Cut</h4>
              <div className="w-80 pr-2">
                <Slider
                  range
                  min={0}
                  marks={cutMarks}
                  max={cutData.length - 1}
                  step={1}
                  onChange={onChangeCutSlider}
                  value={cutSlider}
                />
              </div>
            </div>
            <div className="col-sm-6 mt-5 d-flex align-itmes-center">
              <h4 className="w-10 filter_title">Carat</h4>
              <div className="w-80 pr-2">
                <Slider
                  range
                  min={0}
                  marks={caratMarks}
                  max={caratData.length - 1}
                  step={1}
                  onChange={onChangeCaratSlider}
                  value={caratSlider}
                />
              </div>
            </div>
            <div className="col-sm-6 mt-5 d-flex align-itmes-center">
              <h4 className="w-10 filter_title">Price</h4>
              <div className="w-80 pr-2">
                <Slider
                  range
                  min={0}
                  marks={priceMarks}
                  max={priceData.length - 1}
                  step={1}
                  onChange={onChangePriceSlider}
                  value={priceSlider}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="container product-data-container">
          <div className="row">
            <h2 className="error-msg mb-5">{!isError}</h2>

            <div className="product-data-table-block mt-2 w-100">
              <h3 className="mb-5">{myData.length} Product Available</h3>
              {myData.length > 0 && (
                <div className="product-data-table-block mt-2 w-100">
                  <div className="table__container">
                    <table className="table__items" width="100%">
                      <thead>
                        <tr>
                          <th align="left">&nbsp;</th>
                          <th align="left">Shape</th>
                          <th align="left">Carat</th>
                          <th align="left">Price</th>
                          <th align="left">Cut</th>
                          <th align="left">Color</th>
                          <th align="left">&nbsp;</th>
                        </tr>
                      </thead>
                      <tbody>
                        {myData.map((curElem, index) => (
                          <ProductFilterTable key={index} {...curElem} />
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
              {/* <div className='table__container'>
                                <table className='table__items' width="100%">
                                    <thead>
                                        <tr>
                                            <th align="left">&nbsp;</th>
                                            <th align="left">Shape</th>
                                            <th align="left">Carat</th>
                                            <th align="left">Price</th>
                                            <th align="left">Cut</th>
                                            <th align="left">Color</th>
                                            <th align="left">&nbsp;</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {myData.map((curElem, index) => {
                                            return (
                                                <ProductFilterTable key={index} {...curElem} />
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div> */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FilterProductPage;
